import React, { useState } from "react";
import Header from "./Header";
import { Dialog, Table } from "../../../../../layout";
import ViewProd from "../../../../Catalog/Product/ViewProduct/ViewProd";
import { useFormatPrice } from "hooks";
import TableProdWidget from "../../../../Sales/POS/QuoteSale/ViewQuote/TableProdWidget";

const Products = ({ value, handleClose, setSells }) => {
  const formatPrice = useFormatPrice();
  const [showDetails, setShowDetails] = useState(false);
  const [viewProdId, setViewProdId] = useState();

  const handleView = (val) => {
    setShowDetails(!showDetails);
    setViewProdId(val.prodId);
  };

  return (
    <>
      {value && value.sellItems && (
        <div>
          <Table
            ActionComp={() => <></>}
            HeaderComp={() => <Header {...{ value, setSells, handleClose }} />}
            tblHead={[
              { id: "product", label: "Product" },
              { id: "qty", label: "Qty" },
              { id: "price", label: "Price" },
              { id: "total", label: "Total" },
            ]}
            tblData={value.sellItems.map((item) => {
              return {
                ...item,
                searchTerm: item.prod
                  ? `${item.prod.name} ${item.prod.skuCode}`
                  : "",
                product: (
                  <TableProdWidget
                    {...{
                      handleView,
                      item,
                      discount: item.discount
                        ? `Discount: ${formatPrice(item.disAmt)}`
                        : "",
                    }}
                  />
                ),
                price: <span> {formatPrice(item.price)}</span>,
                total: (
                  <div className="flex flex-col">
                    {/* With discount amount */}
                    <span className="text-[16px]">
                      {formatPrice(item.totalPrice)}
                    </span>
                    {/* Without discount amount */}
                    {item.disAmt > 0 && (
                      <span className="text-[14px] line-through">
                        {formatPrice(item.totalPrice + item.disAmt)}
                      </span>
                    )}
                  </div>
                ),
              };
            })}
          />
        </div>
      )}

      {/* View Product */}
      {showDetails && (
        <Dialog show={showDetails} onClose={false} maxWidth="lg">
          <ViewProd {...{ setShowForm: setShowDetails, id: viewProdId }} />
        </Dialog>
      )}
    </>
  );
};

export default Products;
